/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrConfigSettingsItemMsgVal } from './irrConfigSettingsItemMsgVal';
import { IrrConfigSettingsItemEnumVal } from './irrConfigSettingsItemEnumVal';


export interface IrrConfigSettingsItemVal { 
    boolVal?: boolean;
    enumVal?: IrrConfigSettingsItemEnumVal;
    int32Val?: number;
    int64Val?: number;
    msgVal?: IrrConfigSettingsItemMsgVal;
    repeatedStringVal?: Array<string>;
    stringVal?: string;
    type?: IrrConfigSettingsItemVal.TypeEnum;
}
export namespace IrrConfigSettingsItemVal {
    export type TypeEnum = 'UNKNOWN' | 'STRING' | 'ENUM' | 'INT32' | 'INT64' | 'BOOL' | 'MSG' | 'REPEATED_STRING' | 'DEFAULT';
    export const TypeEnum = {
        UNKNOWN: 'UNKNOWN' as TypeEnum,
        STRING: 'STRING' as TypeEnum,
        ENUM: 'ENUM' as TypeEnum,
        INT32: 'INT32' as TypeEnum,
        INT64: 'INT64' as TypeEnum,
        BOOL: 'BOOL' as TypeEnum,
        MSG: 'MSG' as TypeEnum,
        REPEATED_STRING: 'REPEATED_STRING' as TypeEnum,
        DEFAULT: 'DEFAULT' as TypeEnum
    };
}


